export const moviesData = [
  {
    id: 1,
    title: "Inception",
    description: "A mind-bending thriller",
    genre: "Sci-Fi",
    year: 2010,
    rating: 4.5,
    poster: "https://via.placeholder.com/200",
    trailer: "https://www.youtube.com/embed/YoHD9XEInc0",
  },
  {
    id: 1,
    title: "Inception",
    description: "A mind-bending thriller",
    genre: "Sci-Fi",
    year: 2010,
    rating: 4.5,
    poster: "https://via.placeholder.com/200",
    trailer: "https://www.youtube.com/embed/YoHD9XEInc0",
  },

  {
    id: 1,
    title: "Inception",
    description: "A mind-bending thriller",
    genre: "Sci-Fi",
    year: 2010,
    rating: 4.5,
    poster: "https://via.placeholder.com/200",
    trailer: "https://www.youtube.com/embed/YoHD9XEInc0",
  },
];
